import { render } from "./ModalUpsellItemBranches.vue?vue&type=template&id=5913b251&scoped=true"
import script from "./ModalUpsellItemBranches.vue?vue&type=script&lang=js"
export * from "./ModalUpsellItemBranches.vue?vue&type=script&lang=js"

import "./ModalUpsellItemBranches.vue?vue&type=style&index=0&id=5913b251&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5913b251"]])

export default __exports__